export default __webpack_public_path__ + "static/media/1 (16).37f8fa7b.jpg";